import { useMemo } from "react";

import { SalariesMultiOptionField } from "./SalariesMultiOptionField";

import { QuestionComponentProps } from "@otta/search/containers/Quiz";
import { getAvailableCities } from "@otta/search/utils/locations";

export function SalaryInputLocation(
  props: QuestionComponentProps
): React.ReactElement {
  const options = useMemo(() => {
    const cities = getAvailableCities(false);
    return cities
      .sort((a, b) => a.label.localeCompare(b.label))
      .map(({ label, value }) => ({
        id: value,
        value: label,
      }));
  }, []);

  return (
    <SalariesMultiOptionField
      fieldName="location"
      options={options}
      otherOption
      {...props}
    />
  );
}
